<template>
    <Head>
        <title>Fiat Gateway: Валюты</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <v-navigation/>
        <div class="flex flex-col bg-white">
            <div class="grid grid-cols-4 p-2 gap-4">
                <span>Название</span>
                <span>Тикер</span>
                <span>Активна</span>
            </div>
            <form
                method="post" :action="pageRoute.create"
                class="grid grid-cols-4 border-t p-2 gap-4"
                @submit.prevent="create"
            >
                <v-input v-model="add.name" />
                <v-input v-model="add.ticker" />
                <v-toggle v-model="add.isActive" />
                <v-button>Добавить</v-button>
            </form>
            <div class="grid grid-cols-4 border-t p-2 gap-4" v-for="row in result">
                <div>{{ row.name }}</div>
                <div>{{ row.ticker }}</div>
                <v-toggle v-model="row.isActive" @change="active(row.id, row.isActive)"/>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/FiatGateways';
import VInput from '@/Components/Input';
import VToggle from '@/Components/Toggle';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VInput,
        VToggle,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
    },
    methods: {
        create() {
            this.notifications.push({
                type: 'success',
                title: 'Create currency',
                message: 'Send...',
                timeout: false,
            });
            this.add.post(this.pageRoute.create);
        },
        active(id, isActive) {
            this.notifications.push({
                type: 'success',
                title: 'Update currency',
                message: 'Send...',
                timeout: false,
            });
            useForm({
                active: isActive
            }).put(this.pageRoute.active(id))
        }
    },
    data() {
        return  {
            pageRoute: {
                create: this.route('fiat.currency.create'),
                active:  (id) => this.route('fiat.currency.active', id),
            }
        };
    },
    setup () {
        const add = useForm({
            name: '',
            ticker: '',
            isActive: false,
        });
        return {add}
    },
};
</script>
